import { type Job, jobDb } from '@/modules/job-queue/db'
import { on } from '@/modules/job-queue/event-bus'
import { useToast } from '@/providers/ToastProvider'
import { useEffect, useRef } from 'react'

async function retryJob(jobId: string): Promise<void> {
  await jobDb.jobs.update(jobId, { status: 'pending', error: undefined })
}

export function useJobEvents(): void {
  const { showToast } = useToast()
  const seenRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    const off = on<Job>('job:failed', (job) => {
      if (seenRef.current.has(job.id)) return
      seenRef.current.add(job.id)

      showToast("Oops! Couldn't save your progress. It's kept safe locally.", {
        variant: 'info',
        duration: 8000,
        action: {
          label: 'Retry',
          onClick: () => {
            void retryJob(job.id)
          },
        },
      })
    })

    return off
  }, [showToast])
}
